import { render, staticRenderFns } from "./IconInboxInSolid.vue?vue&type=template&id=41348c50"
import script from "./IconInboxInSolid.vue?vue&type=script&lang=js"
export * from "./IconInboxInSolid.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports